{
  "labels": {
    "textSingleLine": "Texto - Línea única",
    "textMultipleLines": "Texto - Múltiples líneas",
    "date": "Fecha",
    "trueFalse": "Verdadero/Falso",
    "singleDocument": "Documento único",
    "multiDocument": "Múltiples documentos",
    "number": "Número",
    "eMail": "Correo electrónico",
    "phone": "Teléfono",
    "dropDownSingleSelectList": "Lista desplegable de selección única",
    "dropDownMultiSelectList": "Lista desplegable de selección múltiple",
    "comboBox": "Cuadro combinado",
    "timestamp": "Marca de tiempo",
    "featureLink": "Enlace de función"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Campo de texto abierto, una línea",
    "openTextFieldMultipleLines": "Campo de texto abierto, múltiples líneas",
    "formatMmDdYyyy": "Formato MM/DD/AAAA",
    "toggleButton": "Botón de alternar",
    "singleFileUploadField": "Campo de carga de un solo archivo",
    "multipleFileUploadField": "Campo de carga de múltiples archivos",
    "numericInputField": "Campo de entrada numérica",
    "emailAddressInputField": "Campo de entrada de dirección de correo electrónico",
    "format1XxxXxxXxxx": "Formato +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Seleccionar una opción de una lista",
    "selectMultipleOptionsFromAList": "Seleccionar múltiples opciones de una lista",
    "singleOptionDropDownListOpenTextField": "Lista desplegable de una sola opción + campo de texto abierto",
    "dateAndTimeFields": "Campos de fecha y hora",
    "linkToTheFormFeatures": "Enlace a las funciones del formulario"
  }
}
